export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-DE-3-f87a5ce17fcbf3ff361a0dce032971d4.webp";